import $ from "jquery";
window.$ = window.jQuery = $;

require('./swiper');
require('./form');
import Inputmask from "inputmask";
import 'jquery-validation';
import lightGallery from 'lightgallery';


$(document).ready(function () {

    lightGallery(document.getElementById('lightgallery'), {
        speed: 500
    });

    function initPhoneMask() {
        const im = new Inputmask("+\\(380\\) 99-999-99-99", {
            clearIncomplete: true,
            showMaskOnHover: false,
        });

        im.mask($('input[name="phone"]'));
    }
    window.initPhoneMask = initPhoneMask;
    initPhoneMask()


    $('.js-open-spoiler').on('click', function () {
        var currentItem = $(this).closest('.spoiler__item');

        $('.spoiler__item').not(currentItem).find('.spoiler__item-content').slideUp();
        $('.spoiler__item').not(currentItem).find('.spoiler__btn').removeClass('rotate');


        $(this).closest('.spoiler__item').find('.spoiler__item-content').slideToggle();
        $(this).find('.spoiler__btn').toggleClass('rotate');
    });


    $('.header-burger-menu').click(function(){
        $('body').toggleClass('hidden')
        $('.header__wrap').fadeToggle();
        $('.header-burger-menu').toggleClass('active');
    });


    $('a[href="#booking"]').on('click', function (e) {
        e.preventDefault();

        var bookingBlock = $('#booking');
        if (!bookingBlock.length) return;

        // Плавный скролл
        $('html, body').animate({
            scrollTop: bookingBlock.offset().top
        }, 600);
    });


    if ($('.cottage-page__offers-item').length < 10) {
        $('.cottage-page__btn').hide()
    }

    $('.cottage-page__btn-show').on('click', function () {
        $('.cottage-page__btn-hidden').show();
        $(this).hide();
        $('.cottage-page__offers-item').addClass('active');
    });

    $('.cottage-page__btn-hidden').on('click', function () {
        $(this).hide();
        $('.cottage-page__btn-show').show();
        $('.cottage-page__offers-item').removeClass('active');
    });

});
